// extracted by mini-css-extract-plugin
module.exports = {"sectionWrapper":"_2J_Yx","tableHeaderStrip":"_17sZ8","singleTitle":"_3neiQ","tabNavs":"_2CDsq","active":"_1QVMX","contentList":"_2rPJx","subTitle":"_3pWoD"};